import { useState } from 'react';
import { Pagination } from '@repo/ui-web';
import { StateToggle } from '../../components/StateToggle';

export function PaginationShowcase() {
  const variants = ['few-pages', 'many-pages'] as const;
  type PaginationVariant = (typeof variants)[number];

  const [variant, setVariant] = useState<PaginationVariant>('few-pages');
  const [fewPagesCurrentPage, setFewPagesCurrentPage] = useState(1);
  const [manyPagesCurrentPage, setManyPagesCurrentPage] = useState(5);

  const labels = {
    previous: 'Previous page',
    next: 'Next page',
    ellipsis: '...',
    page: (page: number) => `Page ${page}`,
  };

  return (
    <div className="space-y-4">
      <StateToggle
        options={variants}
        value={variant}
        onChange={setVariant}
        label="Variant"
        formatLabel={(value) =>
          value
            .split('-')
            .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
            .join(' ')
        }
      />

      <div className="space-y-3">
        <p className="text-sm font-semibold text-foreground">
          {variant === 'few-pages' ? 'Few pages' : 'Many pages'}
        </p>
        {variant === 'few-pages' ? (
          <>
            <Pagination
              currentPage={fewPagesCurrentPage}
              totalPages={5}
              onPageChange={setFewPagesCurrentPage}
              labels={labels}
            />
            <p className="text-xs text-muted-foreground">Page {fewPagesCurrentPage} of 5</p>
          </>
        ) : (
          <>
            <Pagination
              currentPage={manyPagesCurrentPage}
              totalPages={20}
              onPageChange={setManyPagesCurrentPage}
              labels={labels}
            />
            <p className="text-xs text-muted-foreground">Page {manyPagesCurrentPage} of 20</p>
          </>
        )}
      </div>
    </div>
  );
}
